import React, { useState } from 'react';
import ReactDOM from 'react-dom'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FaMicrophone, FaArrowDown } from 'react-icons/fa';
import * as FontAwesome from 'react-icons/fa'
import './App.css';

function App() {
  const [speechOutputText, setSpeechOutputText] = useState('...')
  const [playList, setPlayList] = useState('')

  // Setup Speech Recognition
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();

  recognition.lang = 'en-GB';
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;

  const micClicked = () => {
    document.querySelector('button').style.backgroundColor = "green";
    recognition.start()

    // speechstart recognition 
    recognition.addEventListener('speechstart', () => {
      console.log('SPEECHSTART: Speech has been detected.');
    })

    // result recognition
    recognition.addEventListener('result', (e) => {
      console.log('RESULT: Result has been detected.');
      document.querySelector('button').style.backgroundColor = "red";

      // Get text from results 
      let last = e.results.length - 1;  
      let text = e.results[last][0].transcript;
      alert(text)
      setSpeechOutputText(text)
      
      // Call emotion detection API
      const getEmotion = fetch('https://emotion-detection-api-c7aaatrzsq-ew.a.run.app/predict?text=' + text);

      // Logging the emotion
      getEmotion
      .then((response) => response.json())
      .then((data) => {
        const emotion = data['label']
        console.log('Emotion: ' + emotion)
        const score = data['score']
        console.log('Emotion score: ' + score)

        // Display the playlists
        switch(emotion) {
          case 'joy':
            setPlayList('https://open.spotify.com/embed/playlist/66F0QrPzMPE9zCj8S1JZ1q?utm_source=generator')           
            break;
          case 'love':
            setPlayList('https://open.spotify.com/embed/playlist/64v2LytooaaE1b5ogu0uMo?utm_source=generator')
            break;
          case 'anger':
            setPlayList('https://open.spotify.com/embed/playlist/37i9dQZF1DX08jcQJXDnEQ?utm_source=generator')
            break;
          case 'fear':
            setPlayList('https://open.spotify.com/embed/playlist/31xXPz9MHntnxHvTQ7SYdu?utm_source=generator')
            break;
          case 'surprise':
            setPlayList('https://open.spotify.com/embed/playlist/3CkJH2FzvJciO8UmkzHCMU?utm_source=generator')
            break;
          case 'sadness':
            setPlayList('https://open.spotify.com/embed/playlist/37i9dQZF1DX7qK8ma5wgG1?utm_source=generator')
            break;
        }
      })
    })

    // stop recognition
    recognition.addEventListener('speechend', () => {
      recognition.stop();
      document.querySelector('button').style.backgroundColor = "red";
    });

    // error recognition
    recognition.addEventListener('error', (e) => {
      console.log('Error: ' + e.error);
    });
  }

  const myLinks = [
    {name: 'github', url: 'https://github.com/shiba517', icon: 'FaGithub'},
    {name: 'linkedin', url: 'https://www.linkedin.com/in/shiba-deb-2099b6105/', icon: 'FaLinkedin'},
    {name: 'portfolio', url: 'https://boisterous-griffin-71958e.netlify.app/', icon: 'FaFortAwesomeAlt'}
  ]

  return (
    <div className="App">
      <h1>spotify mood bot</h1>
      <div>
      {myLinks.map((link) => {
          return (
              <a href={link.url} className="text-center" target="_blank">
                  {React.createElement(FontAwesome[link.icon])}
              </a>
          )
      })}
      </div>

      <h2>Lets find you a playlist</h2>

      <img class="img" src="images/spotify-bot.png" alt="Spotify Bot"></img>

      <div className='micArea'>
        <button style={{backgroundColor: 'red'}} onClick={micClicked}>
          <FaMicrophone className='micIcon'/>
        </button>       
        <p className='micMessage'>Press the mic and tell it what's inside</p>
      </div>
      

      <div className='speechoutputArea'>
        <div className='t'>
          <em className='speechoutput'>{speechOutputText}</em>
        </div>       
      </div>

      {/* <div className='my_navigation'>
        <a href="#playlist"><FaArrowDown className='arrowdownIcon'/></a>
      </div> */}

      <section id='playlist' className='playlist-section'>
        <iframe className="playlist" src={playList} frameBorder="0" allow="autoplay"></iframe>
      </section>
    </div>
  );
}

export default App;
